import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import logo from "assets/images/sls-logo2.png";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { useDispatch } from "react-redux";
import withRouter from "Common/withRouter";

import {
  LoginRequest,
  useLoginMutation,
} from "../../features/account/accountSlice";
import { setCredentials } from "../../features/account/authSlice";

import Cookies from "js-cookie";

const Login = (props: any) => {
  document.title = "Login | Sousse Leaders School";

  const [login, { isLoading }] = useLoginMutation();

  const [formState, setFormState] = React.useState<LoginRequest>({
    login: "",
    password: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (localStorage.getItem("authAffiliate")) {
      navigate("/dashboard");
    }
  }, []);

  const notify = () => {
    Swal.fire({
      icon: "success",
      title: "Bienvenue !",
      showConfirmButton: false,
      timer: 2200,
    });
    navigate("/");
  };

  const Errornotify = (msg: string) => {
    Swal.fire({
      icon: "error",
      title: "Erreur",
      text: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const handleChange = ({
    target: { name, value },
  }: React.ChangeEvent<HTMLInputElement>) =>
    setFormState((prev) => ({ ...prev, [name]: value }));

  const [show, setShow] = React.useState(false);

  const generateCaptcha = () => {
    const ops = ["+", "-", "×"] as const;
    const op = ops[Math.floor(Math.random() * ops.length)];
    let a: number, b: number, answer: number;
    if (op === "+") {
      a = Math.floor(Math.random() * 20) + 1;
      b = Math.floor(Math.random() * 20) + 1;
      answer = a + b;
    } else if (op === "-") {
      a = Math.floor(Math.random() * 20) + 5;
      b = Math.floor(Math.random() * a);
      answer = a - b;
    } else {
      a = Math.floor(Math.random() * 9) + 2;
      b = Math.floor(Math.random() * 9) + 2;
      answer = a * b;
    }
    return { question: `${a} ${op} ${b} = ?`, answer };
  };

  const [captcha, setCaptcha] = React.useState(generateCaptcha);
  const [captchaInput, setCaptchaInput] = React.useState("");
  const [captchaError, setCaptchaError] = React.useState(false);

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaInput("");
    setCaptchaError(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (parseInt(captchaInput) !== captcha.answer) {
      setCaptchaError(true);
      refreshCaptcha();
      return;
    }
    setCaptchaError(false);
    try {
      const user: any = await login(formState).unwrap();
      if (user) {
        dispatch(setCredentials(user));
        Cookies.set("astk", user.central.api_token, { expires: 1 / 4 });
        notify();
      } else {
        Errornotify("Identifiants incorrects !");
      }
    } catch (err: any) {
      Errornotify(err?.data?.message || "Identifiants incorrects !");
    }
  };

  return (
    <React.Fragment>
      <div className="auth-page-wrapper min-vh-100 d-flex" style={{ background: "linear-gradient(135deg, #1a2a6c 0%, #2d4ea3 40%, #3672c4 100%)" }}>
        {/* Left side - branding */}
        <div className="d-none d-lg-flex flex-column justify-content-center align-items-center" style={{ width: "45%", position: "relative", overflow: "hidden" }}>
          {/* Decorative circles */}
          <div style={{ position: "absolute", top: "-10%", left: "-10%", width: "400px", height: "400px", borderRadius: "50%", border: "1px solid rgba(255,255,255,0.08)" }} />
          <div style={{ position: "absolute", bottom: "-15%", right: "-5%", width: "500px", height: "500px", borderRadius: "50%", border: "1px solid rgba(255,255,255,0.06)" }} />
          <div style={{ position: "absolute", top: "30%", right: "10%", width: "200px", height: "200px", borderRadius: "50%", background: "rgba(255,255,255,0.03)" }} />

          <div className="text-center px-5" style={{ position: "relative", zIndex: 1 }}>
            <img
              src={logo}
              alt="SLS Logo"
              style={{ width: "180px", marginBottom: "2rem", filter: "drop-shadow(0 4px 20px rgba(0,0,0,0.3))" }}
            />
            <h2 className="text-white fw-bold mb-3" style={{ fontSize: "1.75rem", letterSpacing: "0.5px" }}>
              Sousse Leaders School
            </h2>
            <p className="text-white-50 mb-4" style={{ fontSize: "1rem", lineHeight: "1.7", maxWidth: "360px", margin: "0 auto" }}>
              Plateforme de gestion scolaire intelligente pour l'administration, les enseignants et les parents.
            </p>
            <div className="d-flex justify-content-center gap-4 mt-4">
              <div className="text-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "48px", height: "48px", background: "rgba(255,255,255,0.12)" }}>
                  <i className="ri-group-line text-white fs-4" />
                </div>
                <span className="text-white-50 fs-12">Élèves</span>
              </div>
              <div className="text-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "48px", height: "48px", background: "rgba(255,255,255,0.12)" }}>
                  <i className="ri-book-2-line text-white fs-4" />
                </div>
                <span className="text-white-50 fs-12">Classes</span>
              </div>
              <div className="text-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "48px", height: "48px", background: "rgba(255,255,255,0.12)" }}>
                  <i className="ri-bar-chart-2-line text-white fs-4" />
                </div>
                <span className="text-white-50 fs-12">Statistiques</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - login form */}
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 px-3" style={{ background: "#f8f9fb", borderRadius: "40px 0 0 40px" }}>
          <div style={{ width: "100%", maxWidth: "420px" }}>
            {/* Mobile logo */}
            <div className="d-lg-none text-center mb-4">
              <img src={logo} alt="SLS" style={{ width: "120px" }} />
            </div>

            <div className="mb-4">
              <h3 className="fw-bold mb-1" style={{ color: "#1a2a6c" }}>
                Connexion
              </h3>
              <p className="text-muted fs-14">
                Accédez à votre espace de gestion scolaire
              </p>
            </div>

            <Form onSubmit={handleSubmit}>
              <div className="mb-3">
                <Form.Label className="fw-semibold text-dark fs-13">
                  <i className="ri-user-3-line me-1 text-primary" />
                  Nom d'utilisateur
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    className="form-control py-2 ps-3"
                    placeholder="Entrez votre identifiant"
                    onChange={handleChange}
                    name="login"
                    value={formState.login}
                    style={{ borderRadius: "10px", border: "1.5px solid #e2e5ec", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Label className="fw-semibold text-dark fs-13 mb-0">
                    <i className="ri-lock-2-line me-1 text-primary" />
                    Mot de passe
                  </Form.Label>
                  <Link to="/forgot-password" className="text-primary fs-12 text-decoration-none">
                    Mot de passe oublié ?
                  </Link>
                </div>
                <div className="position-relative mt-1">
                  <Form.Control
                    className="form-control py-2 ps-3 pe-5"
                    placeholder="Entrez votre mot de passe"
                    name="password"
                    onChange={handleChange}
                    value={formState.password}
                    type={show ? "text" : "password"}
                    style={{ borderRadius: "10px", border: "1.5px solid #e2e5ec", fontSize: "14px" }}
                  />
                  <Button
                    variant="link"
                    className="position-absolute end-0 top-0 text-decoration-none text-muted h-100 d-flex align-items-center pe-3"
                    type="button"
                    onClick={() => setShow(!show)}
                    tabIndex={-1}
                  >
                    <i className={`ri-eye${show ? "-off" : ""}-fill fs-16`} />
                  </Button>
                </div>
              </div>

              <div className="form-check mb-3">
                <Form.Check type="checkbox" id="remember-me" />
                <Form.Label htmlFor="remember-me" className="text-muted fs-13">
                  Se souvenir de moi
                </Form.Label>
              </div>

              <div className="mb-4">
                <Form.Label className="fw-semibold text-dark fs-13">
                  <i className="ri-shield-check-line me-1 text-primary" />
                  Vérification de sécurité
                </Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="d-flex align-items-center justify-content-center px-3 py-2 fw-bold user-select-none"
                    style={{
                      background: "linear-gradient(135deg, #e8edf5, #f0f4fa)",
                      borderRadius: "10px",
                      fontSize: "18px",
                      letterSpacing: "2px",
                      color: "#1a2a6c",
                      minWidth: "140px",
                      fontFamily: "monospace",
                      border: "1.5px dashed #c5cee0",
                    }}
                  >
                    {captcha.question}
                  </div>
                  <Button
                    variant="link"
                    className="text-muted p-1"
                    type="button"
                    onClick={refreshCaptcha}
                    title="Nouveau captcha"
                  >
                    <i className="ri-refresh-line fs-18" />
                  </Button>
                  <Form.Control
                    type="number"
                    placeholder="?"
                    value={captchaInput}
                    onChange={(e) => { setCaptchaInput(e.target.value); setCaptchaError(false); }}
                    className="text-center fw-semibold"
                    style={{
                      borderRadius: "10px",
                      border: `1.5px solid ${captchaError ? "#dc3545" : "#e2e5ec"}`,
                      fontSize: "16px",
                      width: "80px",
                    }}
                  />
                </div>
                {captchaError && (
                  <small className="text-danger mt-1 d-block">
                    <i className="ri-error-warning-line me-1" />
                    Réponse incorrecte, veuillez réessayer.
                  </small>
                )}
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-100 py-2 fw-semibold"
                style={{
                  borderRadius: "10px",
                  fontSize: "15px",
                  background: "linear-gradient(135deg, #1a2a6c 0%, #3672c4 100%)",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 42, 108, 0.3)",
                  transition: "all 0.3s ease",
                }}
              >
                {isLoading ? (
                  <span className="d-flex align-items-center justify-content-center gap-2">
                    <span className="spinner-border spinner-border-sm" />
                    Connexion en cours...
                  </span>
                ) : (
                  <span className="d-flex align-items-center justify-content-center gap-2">
                    <i className="ri-login-box-line fs-16" />
                    Se connecter
                  </span>
                )}
              </Button>
            </Form>

            <div className="text-center mt-4 pt-3" style={{ borderTop: "1px solid #e9ecef" }}>
              <p className="text-muted fs-12 mb-0">
                ©{new Date().getFullYear()} Sousse Leaders School
                <span className="mx-1">·</span>
                Conçu avec <i className="mdi mdi-heart text-danger" /> par l'équipe 3S
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
